import { ISign } from '@app/models/Sign'
import classNames from 'classnames'
import * as React from 'react'
import { Card, CardBody, CardTitle } from 'reactstrap'
import PendingTransferItem from '../containers/PendingTransferItemContainer'

interface ISignCardProps {
  actions?: React.ReactNode
  canEdit?: boolean
  className?: string
  sign: ISign
  style?: React.CSSProperties
}

export default class SignCard extends React.PureComponent<ISignCardProps> {
  public render() {
    return (
      <Card className={this.props.className} style={this.props.style}>
        <CardBody>
          <div className='d-flex justify-content-between align-items-baseline'>
            <CardTitle>
              {this.props.sign.quantity} x {this.props.sign.signType.name}
            </CardTitle>
            <div>{this.props.actions}</div>
          </div>
          <div className='white-space-pre'>{this.props.sign.notes}</div>
          {this._renderPendingTransfers()}
        </CardBody>
      </Card>
    )
  }

  private _renderPendingTransfers() {
    if (this.props.sign.pendingTransfers.size === 0) {
      return null
    }

    return (
      <div className='mt-2'>
        <div className='font-weight-semi-bold'>Pending Transfers</div>
        <div>
          {this.props.sign.pendingTransfers.toArray().map((pending, index) => {
            const itemClasses = classNames({
              'striped-row': index % 2 === 1,
            })

            return (
              <PendingTransferItem
                className={itemClasses}
                key={pending.id}
                signTransfer={pending}
              />
            )
          })}
        </div>
      </div>
    )
  }
}
